@for (angles of semicircle; track angles) {
  <osm-semicircle
    [point]="point"
    [angles]="angles"
    [iMap]="map">
  </osm-semicircle>
}
